RivalIQ.module('graph', function (graph, App, Backbone, Marionette, $, _, d3) {

    'use strict';

    // These widths are computed from values from tables.less as:
    // @sparkline-cell-width-wide - 16 (padding) - 50 (value label) - 3 (interior padding)
    // @sparkline-cell-width-narrow - 16 (padding) - 50 (value label) - 3 (interior padding)
    graph.wideSparklineWidth = 81;
    graph.defaultSparklineWidth = 40;
    graph.defaultSparklineHeight = 18;

    graph.renderSparkline = function (data, el, options) {

        const width = _.get(options, 'width', graph.defaultSparklineWidth);
        const height = _.get(options, 'height', graph.defaultSparklineHeight);

        if (!el) {
            el = document.createElement('div');
            el.className = 'x-spark';
        }

        const x = d3.scale.linear().range([0, width]);
        const y = d3.scale.linear().range([height, 0]);

        const line = d3.svg.line()
            .x(function (d) { return x(d.index); })
            .y(function (d) { return y((d.value === null ? 0 : d.value)); });

        if (!data || (data.length === 0)) {

            return;
        }

        let min = Infinity;
        let max = -Infinity;
        const pruned = _.without(data, null, undefined);

        const total = _.reduce(pruned, function (memo, datum) {

            if (datum > max) {

                max = datum;
            }

            if (datum < min) {

                min = datum;
            }

            return memo + datum;
        }, 0);

        // NOTE if the pruned data was empty then the min and max will still
        // be infinite, and we should set them to zero here
        if (!_.isFinite(min) || !_.isFinite(max)) {

            min = max = 0;
        }

        const average = total / data.length;
        const weightedAverage = average * 0.05;

        x.domain([0, data.length]);
        // NOTE we want to make sure that the domain min is clamped to zero
        y.domain([Math.max(0, min - weightedAverage), max + weightedAverage]);

        const svg = d3.select(el)
            .append('svg')
            .attr('width', width)
            .attr('height', height);

        for (let curr, path, prev, i = 0; i < data.length; i++) {
            curr = {
                index: i,
                value: data[i],
                original: data[i]
            };

            // NOTE only if we have a previous item do we do anything
            if (prev) {

                path = svg.append('path');

                if (curr.original === null) {

                    path.attr('class', 'sparkline nothing')
                        .style('stroke-dasharray', '1,1');

                    // NOTE when we come across an empty data case we want
                    // to make sure that we retain the shape of the line,
                    // that is to say, we don't want to assume a drop to
                    // zero, so, to achieve this, we set the current value
                    // (which is null) to whatever the previous was (which
                    // could be null, but also could be a legitimate number)
                    curr.value = prev.value;
                } else {

                    path.attr('class', 'sparkline');

                    // NOTE when we come across a valid data case we want to
                    // make sure that we imply that the data is discrete,
                    // that is to say that we don't want to assume a climb
                    // from the previous value (of empty)
                    if (prev.original === null) {

                        prev.value = curr.value;
                    }
                }

                path.attr('d', line([prev, curr]));
            }

            prev = curr;
        }

        return el;
    };

    graph.Spark = Marionette.View.extend({
        className: 'x-spark',

        onShow: function () {
            const me = this;

            graph.renderSparkline(me.getOption('data'), me.el);
        }
    });

}, window.d3);
